import React from 'react'

import { ClassificationResult } from '@documents/types'

import { useDocumentCardContext } from '../../context'
import { FailureMessage } from '../../failure-message'
import { getMessage } from '../../utils'
import { Classification } from './classification'

type Props = {
  classificationResults?: ClassificationResult[]
}

export function ClassificationFailed({ classificationResults }: Props) {
  const { hideClassification, hasSupportedClassification } = useDocumentCardContext()
  const message = getMessage({ classificationResults })

  return (
    <div className="flex flex-col gap-3">
      {message ? <FailureMessage isUnsupportedType={!hasSupportedClassification}>{message}</FailureMessage> : null}
      {!hideClassification && classificationResults && <Classification classifications={classificationResults} />}
    </div>
  )
}
